import DialogActions from '@material-ui/core/DialogActions';
import styled from 'styled-components';
import { TableCell } from '@mui/material';
import { theme } from '@attain-sre/attain-design-system';

export const ModalFooterActions = styled(DialogActions)`
  width: 100%;
  padding: 8px 16px;
`;

export const HeaderTableCell = styled(TableCell)`
  && {
    background-color: ${theme.colors.backgroundLight};
    font-weight: 600;
  }
`;

export const CardHeader = styled.div`
  justify-content: center;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xxs};
  width: 100%;
`;

export const CardTitle = styled.h2`
  ${theme.typography.headingSM};
  flex-grow: 1;
  margin: 0;
`;

export const PrimaryText = styled.p`
  ${theme.typography.bodyLG};
  color: ${theme.colors.text};
  margin: 0 0 ${theme.spacing.md};
`;

export const Emphasis = styled.strong`
  font-weight: 600;
`;

export const SubText = styled.p`
  ${theme.typography.bodyMD};
  color: ${theme.colors.text};
  margin: ${theme.spacing.md} 0 0;
`;

export const TableScrollRegion = styled.div`
  max-height: 220px;
  overflow-y: auto;
  width: 100%;
  border: 1px solid ${theme.colors.borderLight};
  border-radius: 4px;
`;
